import { Nullable } from 'frontend/types';
import { OptionsLocalStorage } from 'frontend/types/lessons/editor';

const OPTIONS_STORAGE_VERSION = 3;

function optionsLocalStorageKey() {
  return `lesson_options__v${OPTIONS_STORAGE_VERSION}`;
}

export function saveOptionsToLocalStorage(options: OptionsLocalStorage) {
  try {
    localStorage.setItem(optionsLocalStorageKey(), JSON.stringify(options));
  } catch (e) {
    // noop
  }
}

export function getOptionsFromLocalStorage(): Nullable<OptionsLocalStorage> {
  try {
    const lsOptions = JSON.parse(
      localStorage.getItem(optionsLocalStorageKey()) || '{}',
    ) as OptionsLocalStorage;
    const defaultOptions = {
      renderMathInLivePreview: true,
      isSidebarExpanded: true,
      currentSidebarTab: 'snippets',
    };
    return { ...defaultOptions, ...lsOptions };
  } catch (e) {
    return null;
  }
}
